<template>
    <label class="checkbox"
           v-if="weekday"
           :key="date"
    >
        <input type="checkbox" v-model="isChecked">
        {{ weekday }} [{{ label }}]
    </label>
</template>

<script>
    export default {
        props: ['label', 'date', 'weekday'],
        computed: {
            isChecked: {
                get() {
                    return this.$store.getters.getQueryDatesByDate(this.date).length !== 0
                },
                set(value) {
                    if (this.$store.getters.getQueryDatesByDate(this.date).length === 0) {
                        this.$store.dispatch('addDateToQuery', this.date)
                    } else {
                        this.$store.dispatch('removeDateFromQuery', this.date)
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Day.vue